import { useAppDisplayModeContext } from '@archipro-design/aria';

import type { OverviewLoaderData } from '@modules/professional/page/OverviewPage';
import { useLoaderData } from 'react-router';
import InfoSectionMobile from '~/modules/detail/components/info-section/InfoSectionMobile';
import VerifiedMemberBadge from '~/modules/detail/components/verified-member-badge/VerifiedMemberBadge';

export const YearJoined: React.FC = () => {
    const { professionalOverview } = useLoaderData<OverviewLoaderData>();
    const { mobile } = useAppDisplayModeContext();
    const yearJoined = professionalOverview?.ProfileLiveDate?.substring(0, 4);
    if (!yearJoined) {
        return null;
    }

    return mobile ? (
        <InfoSectionMobile label="ArchiPro Member since">
            {yearJoined}
        </InfoSectionMobile>
    ) : (
        <div className="my-4">
            <VerifiedMemberBadge yearJoined={yearJoined} />
        </div>
    );
};
